module.exports = __webpack_public_path__ + "img/touxiangnan.7c64a4f5.png";